<template>
    <div class="order-wrapper">

        <portal target-el="#filter">
            <div class="sub-header">
                <div class="header-item">
                    <Breadcrumb separator-class="el-icon-arrow-right">
                        <breadcrumb-item :to="{ path: '/indents' }">Outbound</breadcrumb-item>
                        <breadcrumb-item>{{indentNumber}}</breadcrumb-item>
                    </Breadcrumb>
                </div>
            </div>
        </portal>

        <div>
            <ElTabs class="tab-default tab-md">
            <Tab-pane label="Shipment Details">
                <div class="panel-card clearfix">

                    <div class="card-left" v-for="(delivery, ind) in deliveryDetails"
                    v-bind:key="ind">
                        <h4 class="card-list-title">
                        Delivery Details
                        </h4>
                        <div class="card-list active">
                        <h5 class="title-with-icon text-capitalize">
                            <i class="icon-source bg-green-light">
                                <svgicon name="icon-material-grid-md" width="14" height="14" />
                            </i>
                            {{delivery.deliveryId}}
                            <small>{{delivery.no_of_carton}} Cartons</small>
                        </h5>

                        <p class="list-badge">
                            <span class="badge">Wt</span> <label>{{delivery.weight}} KG</label>
                            <span class="badge">Vl</span> <label>{{delivery.vol}} CFT</label>
                            <span class="badge">Qt</span> <label>{{delivery.qty}} pieces</label>
                        </p>

                        <h5>
                            <small class="mb-10 text-capitalize"></small>

                            <i class="action-icon">
                            <svgicon name="delete" width="10" height="10" />
                            </i>
                        </h5>
                        </div>
                    </div>

                    <div class="card-right"
                    v-if="!isOrderLoading && currentIndent && shipPackCode.length">
                        <div class="card-content p-0">
                            <div class="inner-left">
                                <div class="card-box-bordered border-0">
                                    <h5 class="mb-5">
                                        Carton Details
                                    </h5>
                                    <div class="d-flex">
                                       <CartonTable

                                       :tableData="tableCartonData">
                                       </CartonTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="status-msg"
                    >
                    <span class="p-0">
                     <img :src="Indent" width="200" height="150" alt=""/>
                    </span>
                    </div>

                </div>
            </Tab-pane>
            </ElTabs>
        </div>
        <div class="default-slider slider-dark with-footer" direction="right">
            <EditDetails
            v-if="!isOrderLoading && currentIndent && shipPackCode.length"
            :indent="currentIndent"
            :shipPackCode="shipPackCode">
            </EditDetails>
        </div>

    </div>
</template>

<script>
import Indent from '@common/asset/images/Indent.gif';
import { mapGetters } from 'vuex';
import CartonTable from '../../components/create-update/carton-table';
import EditDetails from '../../components/create-update/hach-edit-indent';


export default {
  components: {
    CartonTable,
    EditDetails,
  },
  data() {
    return {
      currentIndent: null,
      currentIndentCartonDetails: [],
      deliveryNumbers: [],
      Indent,
      shipPackCode: [],
      caution_code: null,
    };
  },
  computed: {
    ...mapGetters({
      isOrderLoading: 'order/isOrderLoading',
    }),
    deliveryDetails() {
      const result = [];
      if (this.currentIndent && this.currentIndent.package_details) {
        this.deliveryNumbers.forEach((deliveryID) => {
          const obj = {};
          obj.no_of_carton = this.currentIndent.package_details[deliveryID].no_of_carton;
          obj.deliveryId = deliveryID;
          let totVol = 0;
          let totWt = 0;
          let totQty = 0;

          this.currentIndent.package_details[deliveryID].carton_details.forEach((carton) => {
            totVol += parseInt(carton.net_volume, 10);
            totWt += parseInt(carton.net_weight, 10);
            totQty += carton.total_quantity;
          });
          obj.vol = totVol;
          obj.weight = totWt;
          obj.qty = totQty;
          result.push(obj);
        });
      }
      return result;
    },
    indentNumber() {
      return this.currentIndent && this.currentIndent.order_number;
    },
    tableCartonData() {
      return this.currentIndentCartonDetails;
    },
  },
  async created() {
    try {
      this.currentIndent = await this.$store.dispatch(
        'order/find',
        this.$route.params.orderId,
      );
      if (this.currentIndent && this.currentIndent.package_details) {
        this.deliveryNumbers = Object.keys(this.currentIndent.package_details);
        if (this.deliveryNumbers.length) {
          this.currentIndentCartonDetails =
        this.currentIndent.package_details[this.deliveryNumbers[0]].carton_details;
        }
        this.caution_code = this.currentIndent.caution_code;
      }
      let param = {};
      if (this.currentIndent.caution_code) {
        param = {
          caution_codes__icontains: this.currentIndent.caution_code,
        };
      }
      this.shipPackCode = await this.$store.dispatch('mdmV2/search', {
        section: 'shipmethod',
        params: param,
        isMieone: true,
      });
    } catch (err) {
      throw err;
    }
  },

};
</script>
